import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=0ae61cc2&"
import script from "./Home.vue?vue&type=script&setup=true&lang=js&"
export * from "./Home.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports